import { Alert, Stack, Typography } from "@mui/material";

import { ShipmentTrackingLinkPanel } from "components/ShipmentTrackingLink";
import { useShipperShipmentPageContext } from "hooks";

interface Props {
  dividerComponent: JSX.Element;
}

export function ShipmentTrackingLinkSection(props: Props) {
  const { dividerComponent } = props;
  const { shipment, onRefresh } = useShipperShipmentPageContext();
  const { link_expected: linkExpected, link_due: linkDue } =
    shipment?.tracking_link_info ?? {};

  return (
    <ShipmentTrackingLinkPanel
      dividerComponent={dividerComponent}
      shipment={shipment}
      onRefresh={onRefresh}
      showWarningOnCopy
      addButtonLabel="Add tracking link"
      addPromptComponent={
        <Stack mb="1rem" direction="column" spacing={1}>
          <Typography mt="1rem" variant="h6">
            {linkExpected
              ? "No tracking link created yet."
              : "No tracking link provided yet."}
          </Typography>
          {linkExpected && linkDue && (
            <Alert severity="warning">
              The tracking link is due. Carrier has been sent a reminder.
            </Alert>
          )}
        </Stack>
      }
    />
  );
}
